import { AUTH_LOGOUT, AUTH_CHECK } from 'react-admin';
import { Auth } from 'aws-amplify';


export default (type, params) => {
    if (type === AUTH_LOGOUT) {
        Auth.signOut()
            .then(data => console.log(data))
            .catch(err => console.log(err));
        return Promise.resolve();
    }
    if (type === AUTH_CHECK) {
        return Auth.currentSession().then(function (session) {
            if (!session) {
                return Promise.reject('You need to sign in to access that page.');
            }

            return session;
        });
    }
    return Promise.resolve();
};